module.exports = __webpack_public_path__ + "img/icon-attch_on.ee43c58e.svg";